var path = '/home/travis/build/orizens/echoes/src/components/navigator/navigator.tpl.html';
var html = "<ul id=library-nav class=\"nav nav-list nicer-ux library-nav navigator\"><li class=nav-header>Library<li ng-repeat=\"view in $ctrl.views\" ng-class=\"{ active: view.active }\"><a href=\"#{{:: view.ref }}\"><i class=\"fa fa-{{:: view.icon }}\"></i> {{:: view.label }}</a></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/navigator/navigator.tpl.html
 ** module id = 123
 ** module chunks = 1
 **/